<template>
  <div class="slider slider6">
    <!-- 内容区域 -->
    <div
      class="
        swiper-silder6
        position-absolute
        ani
        d-flex
        align-items-start
        justify-content-center
      "
    >
      <swiper
        :options="silderOption"
        ref="silderSwiper"
        :style="common.handleScale()"
      >
        <swiper-slide v-for="(n, index) in 6" :key="index">
          <div :class="['silder-bg' + n]" class="silder-bg-size"></div>
        </swiper-slide>
      </swiper>
      <div
        class="
          swiper-pagination swiper-pagination-silder6
          cursor
          position-absolute
        "
        slot="pagination"
      ></div>
    </div>
  </div>
</template>
<script>
let vm = null;
export default {
  data() {
    return {
      roleDetailUrl: "",
      musicUrl: "",
      fpage: 0, // 父当前页
      nextShow: true,
      silderOption: {
        autoplay: {
          disableOnInteraction: false,
          delay: 3000,
        },
        loop: true,
        direction: "horizontal",
        effect: "fade",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        pagination: {
          el: ".swiper-pagination-silder6",

          touchRatio: 1, //解决滑动卡顿
          longSwipesRatio: 0.1,
          threshold: 10, //如果触摸距离小于该值滑块不会被拖动
          followFinger: false,
          bulletClass: "my-bullet", //需设置.my-bullet样式
          clickable: true, // 允许点击小圆点跳转
          renderBullet: function (index, className) {
            switch (index) {
              case 0:
                name = "";
                break;
              case 1:
                name = "";
                break;
              case 2:
                name = "";
              case 3:
                name = "";
              default:
                name = "";
            }
            return (
              '<div class="' +
              className +
              " " +
              className +
              [index] +
              '"><i>' +
              name +
              "</i></div>"
            );
          },
        },
      },
    };
  },
  created() {
    vm = this;
  },
  updated() {},
  mounted() {},
};
</script>
<style lang="scss" >
.swiper-silder6 {
  width: 100%;
  height: 100%;
  background: #000;
  z-index: 6;
  .swiper-container {
    min-height: 1080px;
    transform-origin: center top;
  }

  // 各个角色，不同的背景，点击该背景中角色，切换
  // 角色1
  .silder-bg-size {
    width: 1920px;
    height: 1080px;
  }
  .silder-bg1 {
    background: url("../../assets/img/characters/silder1.png") top ;
    background-size: 100% 100%;
  }

  // 角色2
  .silder-bg2 {
    background: url("../../assets/img/characters/silder2.png") top ;
    background-size: 100% 100%;
  }
  // 角色3
  .silder-bg3 {
    background: url("../../assets/img/characters/silder3.png") top ;
    background-size: 100% 100%;
  }
  // 角色4
  .silder-bg4 {
    background: url("../../assets/img/characters/silder4.png") top ;
    background-size: 100% 100%;
  }
  // 角色5
  .silder-bg5 {
    background: url("../../assets/img/characters/silder5.png") top ;
    background-size: 100% 100%;
  }
  // 角色5
  .silder-bg6 {
    background: url("../../assets/img/characters/silder6.png") top ;
    background-size: 100% 100%;
  }
  .role-bg {
    z-index: 2;
    width: 100%;
  }
  // box
  .cnt {
    width: 1400px;
    height: 1080px;
    z-index: 999;
  }
  // 角色轮播图分页圆点更改背景
  .swiper-pagination-silder6 {
    width: 640px !important;
    height: 80px;
    background: url("../../assets/img/characters/swiper-pag-bg.png") top center;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    margin-left: -320px;
    left: 50% !important;
    bottom: 3vh !important;
    .swiper-pagination-bullet-active {
      background: transparent;
    }
    .my-bullet {
      display: flex;
      justify-content: center;
      i {
        display: block;
        width: 76px;
        height: 88px;
        margin-top: -4px;
        margin-left: -5px;
      }
    }
    // 选中后的按钮图
    .my-bullet0.swiper-pagination-bullet-active i {
      background: url("../../assets/img/characters/bullet1.png") center top;
      background-size: 100% 100%;
    }
    .my-bullet1.swiper-pagination-bullet-active i {
      background: url("../../assets/img/characters/bullet2.png") center top;
      background-size: 100% 100%;
    }
    .my-bullet2.swiper-pagination-bullet-active i {
      background: url("../../assets/img/characters/bullet3.png") center top;
      background-size: 100% 100%;
    }
    .my-bullet3.swiper-pagination-bullet-active i {
      background: url("../../assets/img/characters/bullet4.png") center top;
      background-size: 100% 100%;
    }
    .my-bullet4.swiper-pagination-bullet-active i {
      background: url("../../assets/img/characters/bullet5.png") center top;
      background-size: 100% 100%;
    }
    .my-bullet5.swiper-pagination-bullet-active i {
      background: url("../../assets/img/characters/bullet6.png") center top;
      background-size: 100% 100%;
    }
  }
}

#nameAttrValue {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/characters.vue